import {useContext, useEffect, useState} from "react";
import {Alert, Button, Form} from "react-bootstrap";
import logoWhite from '../assets/img/logo-white.png'
import logo from '../assets/img/logo.png'
import './Login.css'
import API, {getMe, HandleError} from "../API";
import AppContext from "../AppContext";
import {useSnackbar} from "notistack";
import {Link, Navigate, useSearchParams} from "react-router-dom";
import {PiLightningBold} from "react-icons/pi";
import { useTranslation } from 'react-i18next';

export default function Login() {
    const { t, i18n } = useTranslation();

    const versionNotice = window.location.search.indexOf('version_notice=1') !== -1
    const demoLogin = window.location.search.indexOf('demo=1') !== -1
    const { enqueueSnackbar } = useSnackbar()
    const app = useContext(AppContext)
    const [queryParams, setQueryParams] = useSearchParams();

    const login_token = queryParams.get('lt') ?? ''
    const [form, setForm] = useState({
        values: {
            email: demoLogin ? 'demo@turbotheorie.nl' : '',
            password: demoLogin ? 'demo' : '',
            lt: demoLogin ? '' : login_token
        },
        errorFields: {},
        error: false,
        loading: false,
    })

    useEffect(() => {
        app.logout(true)
        if(demoLogin || form.values.lt.length === 180)
            handleSubmit()

    }, [])

    const [redirect, setRedirect] = useState('')

    const handleSubmit = async (e) => {
        e?.preventDefault();
        if((!form.values.email || !form.values.password) && (!form.values.lt || form.values.lt.length !== 180))
            return;

        setForm({...form, loading: true })
        try {
            const resToken = await API({
                method: 'POST',
                url: `/login`,
                data: {...form.values}
            })

            if (resToken.status < 200 || resToken.status > 299)
                throw resToken.data;

            const resMe = await getMe(resToken.data.token)
            if (resMe.status < 200 || resMe.status > 299)
                throw resMe

            setForm({...form, loading: false})
            app.login(resToken.data.token, resMe.me, {...app.ui, ...resMe.ui})
            setRedirect('/');
        }
        catch(e) {
            setForm({...form, loading: false})
            HandleError(e, 'Error', enqueueSnackbar, app.logout);
        }
    }

    const onChange = (e) => {
        let values = {...form.values}
        values[e.target.name] = e.target.value
        setForm({...form, values: values})
    }

    return (redirect ? <Navigate to={redirect} /> : <div id="page-login">
        <div className="login-banner">
            <div className="center-logo">
                <img src={logoWhite} alt=""/>
            </div>
            <h1>{t('login.heading')}</h1>
        </div>
        <div className="login-form-box">
            <div className="form-inner">
                <div className="login-logo">
                    <img src={logo} alt="" />
                </div>
                <div className="form-login">
                    <h3 className="mb-4">{t('login.title')}</h3>
                    {versionNotice && <Alert variant="warning" style={{fontSize: 16}}>
                        <div>
                            <PiLightningBold />&nbsp;
                            {t('login.versionNotice')}
                        </div>
                    </Alert>}
                    <form onSubmit={handleSubmit}>
                        <Form.Group className="mb-3 form-floating" controlId="email">
                            <Form.Control type="email" placeholder={t('form.email')} name="email" value={form.values.email} onChange={onChange} />
                            <Form.Label>{t('form.email')}</Form.Label>
                            {'email' in form.errorFields ? <Form.Text className="text-muted">
                                {form.errorFields['email']}
                            </Form.Text> : ''}
                        </Form.Group>
                        <Form.Group className="mb-3 form-floating" controlId="password">
                            <Form.Control type="password" placeholder={t('form.password')} name="password" value={form.values.password} onChange={onChange} />
                            <Form.Label>{t('form.password')}</Form.Label>
                            {'password' in form.errorFields ? <Form.Text className="text-muted">
                                {form.errorFields['password']}
                            </Form.Text> : ''}
                        </Form.Group>
                        <Button color={"primary"} type="submit">{t('button.login')}</Button>
                    </form>
                </div>
                <div className="login-options">
                    <p>
                        {t('login.lostPassword')}
                        <br />
                        <Link to="/password-reset"><strong>{t('login.link.newPassword')}</strong></Link>
                    </p>
                    <p>
                        {t('login.newAccount')}
                        <br />
                        <Link to="/signup"><strong>{t('button.signup')}</strong></Link>
                    </p>
                    <p className="text-center text-muted small pt-5 pb-5">
                        &copy; TurboTheorie B.V.
                    </p>
                </div>
            </div>
        </div>
    </div>)
}